var $6528cfe228d0a856$exports = {};
$6528cfe228d0a856$exports = {
    "colorFormat": `Sz\xednform\xe1tum`,
    "hex": `Hex`,
    "hsb": `HSB`,
    "hsl": `HSL`,
    "rgb": `RGB`
};


export {$6528cfe228d0a856$exports as default};
//# sourceMappingURL=hu-HU.mjs.map
